import { SCHEMAS } from './product.model';
import { NavUtils } from './nav.utils';
export const UserContext = {
	navItems: [
		{
			label: 'Dashboard',
			route: '/',
			icon: 'fa-tachometer-alt',
			module: 'main',
		},
		{
			label: 'Invision',
			route: '/invision',
			icon: 'fa-project-diagram',
			module: 'main',
			title: 'Modules',
		},
		{
			label: 'Dashboard',
			route: '/invision',
			icon: 'fa-tachometer-alt',
			module: 'invision',
		},
		{
			label: 'Orders',
			route: '/',
			icon: 'fa-inbox ',
			module: 'invision',
		},
		{
			label: 'Messages',
			route: '/',
			icon: 'fa-envelope',
			module: 'invision',
		},
		{
			label: 'Quality Assurance',
			route: '/',
			icon: 'fa-check-circle',
			module: 'invision',
		},
		{
			label: 'Intelligence',
			route: '/intelligence',
			icon: 'fa-server',
			module: 'main',
			title: 'Modules',
		},
		// Intelligence
		// {
		// 	label: 'Dashboard',
		// 	route: '/intelligence/dashboard',
		// 	icon: 'fa-poll',
		// 	module: 'intelligence',
		// 	title: 'quality review',
		// 	subTitle: 'Overall Quality',
		// },
		{
			label: 'Inbox',
			route: '/intelligence/inbox',
			icon: 'fa-inbox ',
			module: 'intelligence',
			title: 'quality review',
			subTitle: 'Inbox',
			defaultView: true,
		},
		{
			label: 'Import',
			route: '/intelligence/import',
			icon: 'fa-file-import',
			module: 'intelligence',
			title: 'Order Management',
			subTitle: 'Import Order',
		},
		// Appraisal Desktop
		{
			label: 'Inbox',
			route: '/desktop/inbox',
			icon: 'fa-inbox ',
			module: 'appraisal-desktop',
			title: 'Review',
			subTitle: 'Inbox',
			defaultView: true,
		},
		// Identity System
		{
			label: 'User List',
			route: '/identity-system/user',
			icon: 'fa-users',
			module: 'identity-system',
			title: 'User Management',
			subTitle: 'User List',
			defaultView: true,
		},
		{
			label: 'Organizations',
			route: '/identity-system/management/organizations',
			icon: 'fa-sitemap',
			module: 'identity-system',
			title: 'organizations Management',
			subTitle: 'Organizations List',
		},
		{
			label: 'Security Groups',
			route: '/identity-system/management/security-groups',
			icon: 'fa-layer-group',
			module: 'identity-system',
			title: 'Security Groups',
			subTitle: 'Security Groups List',
		},
		// Rule Set List
		{
			label: 'Rule Search',
			route: '/rule-engine/rule-search',
			icon: 'fa-magnifying-glass',
			module: 'rule-engine',
			title: 'Rule Search',
			subTitle: 'Rule Search',
			defaultView: true
		},
		// Smart QC
 		{
 			label: 'Smart QC ',
 			route: '/rule-engine/smart-qc',
 			icon: 'fa-lightbulb',
 			module: 'rule-engine',
 			title: 'Smart QC',
 			subTitle: 'Smart QC',
 			defaultView: true
 		},
		{
			label: 'Rule Ticket Manager',
			route: '/rule-engine/rule-ticket-manager',
			icon: 'fad fa-solid fa-ticket',
			module: 'rule-engine',
			title: 'Rule Ticket Manager',
			subTitle: 'Rule Ticket Manager',
		},
		// Rule Set List
		{
			label: 'Ruleset List',
			route: '/rule-engine/rule-sets',
			icon: 'fa-cogs',
			module: 'rule-engine',
			title: 'Rule Engine',
			subTitle: 'Ruleset List'
		},
		{
			label: 'Ruleset Mapper',
			route: '/rule-engine/rule-set-mappings',
			icon: 'fad fa-folder-tree',
			module: 'rule-engine',
			title: 'RuleSet Management',
			subTitle: 'Ruleset Mapper',
		},
		{
			label: 'Alternative RulesMapper',
			route: '/rule-engine/alternative-rules-mappers',
			icon: 'fad fa-folder-tree',
			module: 'rule-engine',
			title: 'Alternative RulesMapper',
			subTitle: 'Ruleset Mapper',
		},
	],
	schema: [
		{
			type: SCHEMAS.CVReview_1004,
			navItems: NavUtils.getSchemaNav(SCHEMAS.CVReview_1004),
		},
		{
			type: SCHEMAS.CVReview_1073,
			navItems: NavUtils.getSchemaNav(SCHEMAS.CVReview_1073),
		},
		{
			type: SCHEMAS.CVReview_1075,
			navItems: NavUtils.getSchemaNav(SCHEMAS.CVReview_1075),
		},
		{
			type: SCHEMAS.CVReview_2055,
			navItems: NavUtils.getSchemaNav(SCHEMAS.CVReview_2055),
		},
		{
			type: 'revised',
			navItems: [
				{
					label: 'Revised Fields',
					route: 'intelligence/quality/revisions',
					path: 'revisions',
					basePath: 'intelligence/quality/',
					icon: 'fas fa-check-double',
					isRevised: true,
					module: 'quality',
					badge: '',
				},
			],
		},
		{
			type: SCHEMAS.InspectionReport,
			navItems: NavUtils.getSchemaNav(SCHEMAS.InspectionReport),
		},
		{
			type: SCHEMAS.CVReviewAltVal,
			navItems: NavUtils.getSchemaNav(SCHEMAS.CVReviewAltVal, true),
		}
	],
};

export interface UserLogin {
	isActive?: boolean;
	navItems?: any;
	schema?: any;
}
